import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Box, Flex, Switch, Tooltip } from "@mantine/core";
import {
  ISpaceValidation,
  SPACE_VALIDATIONS,
} from "../../RoomSideBar/SpaceValidations/spaceValidationsUtils";
import React from "react";
import { thunkRunSpaceValidations, toggleSpaceValidationSpecInRedux } from "../designSlice";
import { FaInfoCircle } from "react-icons/fa";

const ValidationTableSettings: React.FC = () => {
  const activeSpaceValidationSpecs = useAppSelector(
    (state) => state.design.activeSpaceValidationSpecs
  );

  const spaceValidationRun = useAppSelector((state) => state.design.spaceValidationRun);

  const dispatch = useAppDispatch();

  const toggle = (validation: ISpaceValidation) => {
    dispatch(toggleSpaceValidationSpecInRedux(validation.id));
    if (spaceValidationRun.active) {
      dispatch(thunkRunSpaceValidations(false));
    }
  };

  return (
    <Box style={{ border: "1px solid #ccc" }}>
      <h5 style={{ margin: 0, padding: 0 }}>Regler</h5>
      {SPACE_VALIDATIONS.map((validation) => {
        return (
          <Flex p={4} key={validation.id}>
            <Tooltip label={validation.description}>
              <span style={{ padding: 0, fontSize: "12px" }}>
                <FaInfoCircle />
              </span>
            </Tooltip>
            <Switch
              checked={activeSpaceValidationSpecs[validation.id]}
              onChange={() => toggle(validation)}
              label={validation.title}
            />
          </Flex>
        );
      })}
    </Box>
  );
};

export default ValidationTableSettings;
